<div class="ztv-feature-container" [formGroup]="ztvFormGroup">
  <div class="row enable-feature">
    <div class="col-2 custom-button">
      @if (featureHasProperty('ZtvEnabled')) {
        <div
          class="signifyBookmd rSetZtv"
          >
          Enable feature
          <label class="enable-feature" aria-hidden="true">
            <input
              type="checkbox"
              [checked]="propertiesInfo['ZtvEnabled'].value"
              formControlName="ZtvEnabled"
              name="Rset"
              class="primary-checkbox"
              id="Rset"
              (change)="onCheckboxChange('ZtvEnabled', null, $event.target.checked)"
              aria-label="Enable feature"
              />
              <!-- added ids here -->
              <span  id="Ztv-enable-feature-checkbox" class="extra-border-enablefeat"></span>
            </label>
          </div>
        }
      </div>
    </div>
    @if (featureHasProperty('ZtvMinDimLevel')) {
      <ng-container
        [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'ZtvMinDimLevel',
        unit: '%',
        propertyTitle: ['Min dim level'],
        hasOneOf: propertiesInfo['ZtvMinDimLevel'].hasOneOf
      }"
      ></ng-container>
    }
    @if (featureHasProperty('ZtvMinDimCurrent')) {
      <ng-container
        [ngTemplateOutlet]="sliderWithInputField"
      [ngTemplateOutletContext]="{
        propertyName: 'ZtvMinDimCurrent',
        unit: 'mA',
        propertyTitle: propertiesInfo['ZtvMinDimCurrent'].hasOneOf
          ? ['Min dim', 'current']
          : ['Min dim current'],
        hasOneOf: propertiesInfo['ZtvMinDimCurrent'].hasOneOf
      }"
      ></ng-container>
    }
    @if (featureHasProperty('ZtvCurveSelection')) {
      <div
        class="row curve-selection"
        [ngClass]="{ ztvdisbaled: ztvdisbaled }"
        >
        <div id="ztv-curveSelection-text" class="col-1 label signifyBookmd nowrap">Curve selections</div>
        <div class="col-4 select-curve">
          <!-- added id here -->
          <select id="Ztv_CurveSelection_Dropdown"  formControlName="ZtvCurveSelection" class="select-input">
            @for (curve of propertiesInfo['ZtvCurveSelection'].enumItems; track curve; let i = $index) {
              <option
                [attr.id]="'Ztv_CurveSelection_Option_' + i"
                [value]="curve.value"
                >
                {{ curve.label }}
              </option>
            }
          </select>
        </div>
      </div>
    }
    @if (featureHasProperty('ZtvDimToOffEnabled')) {
      <div
        class="box-container col-5"
        >
        <div class="box">
          @if (featureHasProperty('ZtvDimToOffEnabled')) {
            <div class="signifyBookmd dim-to-off-enable-container d-flex align-items-center"
              >
          <label [ngClass]="{
                      'checkbox-disabled': propertiesInfo['ZtvDimToOffEnabled'].disabled
                    }" class="checkbox-label" aria-hidden="true">
                <input type="checkbox" [checked]="propertiesInfo['ZtvDimToOffEnabled'].value" formControlName="ZtvDimToOffEnabled"
              name="ZtvDimToOffEnabled" class="primary-checkbox" id="ZtvDimToOffEnabled" (change)="
                    onCheckboxChange(
                      'ZtvDimToOffEnabled',
                      null,
                      $event.target.checked
                    )
                  " aria-label="Enable dim to off" />
                  <!-- added id here -->
                  <span id="ZtvDimToOffEnabledCheckBox"
                  class="extra-border-enablefeat"></span>
                </label>
                <div id="ztv-enable-dimToOff-text" class="nowrap ml-2">Enable dim to off</div>
              </div>
            }
            @if (featureHasProperty('DimToOffThreshold')) {
              <div class="dim-to-off-threshold">
                @for (
                  item of propertiesInfo['DimToOffThreshold'].enumItems; track
                  item; let i = $index) {
                  <div class="signifyBookmd dim-to-off-threshold-item d-flex align-items-center">
            <label [ngClass]="{
                      'checkbox-disabled':
                        propertiesInfo['DimToOffThreshold'].disabled
                    }" class="checkbox-label" aria-hidden="true">
                      <input type="checkbox" [checked]="item.selected" [(ngModel)]="item.selected"
                        [ngModelOptions]="{ standalone: true }" [disabled]="propertiesInfo['DimToOffThreshold'].disabled"
                class="primary-checkbox" [id]="threshold + i" (change)="
                      onCheckboxChange(
                        'DimToOffThreshold',
                        item.value,
                        $event.target.checked
                      )
                    " [attr.aria-label]="item.label" />
                        <span [attr.id]="'ZtvDimToOffThresholdCheckBox-' + i" class="extra-border-enablefeat"></span>
                      </label>
                      <span [attr.id]="'ztv-dimToOffThreshold-text-' + i" class="nowrap ml-2">{{ item.label }}</span>
                    </div>
                  }
                </div>
              }
              @if (featureHasProperty('FastFadeEnabled')) {
                <div class="signifyBookmd fast-fade-enable-container d-flex align-items-center"
                  >
          <label [ngClass]="{
                    'checkbox-disabled': propertiesInfo['FastFadeEnabled'].disabled
                  }" class="checkbox-label" aria-hidden="true">
                    <input type="checkbox" [checked]="propertiesInfo['FastFadeEnabled'].value" formControlName="FastFadeEnabled"
              name="FastFadeEnabled" class="primary-checkbox" id="FastFadeEnabled" (change)="
                    onCheckboxChange('FastFadeEnabled', null, $event.target.checked)
                  " aria-label="Enable fast fade" />
                      <!-- added id here -->
                      <span id="ZtvFastFadeEnabledCheckBox"
                      class="extra-border-enablefeat"></span>
                    </label>
                    <span class="nowrap ml-2">Enable fast fade</span>
                  </div>
                }
                @if (!featureHasProperty('FastFadeEnabled') && featureHasProperty('DimToOffThreshold')) {
                  <div class="fast-fade-separator"
                  ></div>
                }
                @if (featureHasProperty('FadeOnTime')) {
                  <div class="row fade-on-time">
                    <div id="ztv-fadeOnTime-text" class="input-label signifyBookmd curve col-3 fade-select-label">Fade on time:</div>
                    <div class="col-7 d-flex align-items-center">
                      <!-- added id here -->
                      <select id="Ztv_FadeOnTime_Dropdown" formControlName="FadeOnTime" class="select-input">
                        @for (item of propertiesInfo['FadeOnTime'].enumItems; track item; let i = $index) {
                          <option [attr.id]="'Ztv_FadeOnTime_Option_' + i" [value]="item.value">
                            {{ item.label }}
                          </option>
                        }
                      </select>
                      <span id="ztv-fadeOnTime-unit" class="signifyBookmd unit dropdown-unit">s</span>
                    </div>
                  </div>
                }
                @if (featureHasProperty('FadeOffTime')) {
                  <div class="row fade-off-time">
                    <div id="ztv-fadeOffTime-text" class="input-label signifyBookmd curve col-3 fade-select-label">Fade off time:</div>
                    <div class="col-7 d-flex align-items-center">
                      <!-- added id here -->
                      <select id="Ztv_FadeOffTime_Dropdown" formControlName="FadeOffTime" class="select-input">
                        @for (item of propertiesInfo['FadeOffTime'].enumItems; track item; let i = $index) {
                          <option [attr.id]="'Ztv_FadeOffTime_Option_' + i" [value]="item.value">
                            {{ item.label }}
                          </option>
                        }
                      </select>
                      <span id="ztv-fadeOffTime-unit" class="signifyBookmd unit dropdown-unit">s</span>
                    </div>
                  </div>
                }
              </div>
            </div>
          }
        </div>







        @if (featureHasProperty('FadeOffTime') || featureHasProperty('FadeOnTime')) {
          <div class="row note-back-new">
            <span id="ztv-note-text" class=" col-11 note-text signifyBookmd"><span class="signifyBoldmd">Note:</span> if "Fade on time" or "Fade off time" of "0" is selected, it will
          result in typical fade time of 300ms</span>
        </div>
      }
      @if (featureHasProperty('OverrideMode')) {
        <div class="override-section box-container">
          <div id="ztv-overrideMode-title" class="col-12 signifyBookmd override-title">Select 0-10V override logic</div>
          @for (item of propertiesInfo['OverrideMode'].enumItems; track item; let i = $index) {
            <div class="override-item d-flex align-items-center">
              <label [ngClass]="{ 'checkbox-disabled': propertiesInfo['OverrideMode'].disabled }" class="checkbox-label" aria-hidden="true">
                <input
                  type="checkbox"
                  [checked]="item.selected"
                  [(ngModel)]="item.selected"
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="propertiesInfo['OverrideMode'].disabled"
                  class="primary-checkbox"
                  [attr.id]="'ZtvOverrideMode-' + i"
                  (change)="onCheckboxChange('OverrideMode', item.value, $event.target.checked)"
                  [attr.aria-label]="item.label"
                />
                <span [attr.id]="'ZtvOverrideModeCheckBox-' + i" class="extra-border-enablefeat" [ngClass]="{ 'override-corrupt-checkbox': overrideModeError }"></span>
              </label>
              <span [attr.id]="'ztv-overrideMode-text-' + i" class="signifyBookmd nowrap ml-2">{{ item.label }}</span>
            </div>
          }
        </div>
      }

      <ng-template
        #sliderWithInputField
        let-propertyName="propertyName"
        let-propertyTitle="propertyTitle"
        let-unit="unit"
        let-hasOneOf="hasOneOf"
        >
        <div
          [attr.id]="'ztv-slider-section-' + propertyName"
          class="section-item slider-item input-item"
          [formGroup]="ztvFormGroup"
      [ngClass]="{
        'slider-field-disbaled': propertiesInfo[propertyName].disabled,
        'container-with-slider': !quickConfigvalue,
        'slider-field-not-on-use': !propertiesInfo[propertyName].useProp
      }"
          >
          <div class="input-label slider-title col-1">
            @if (propertiesInfo[propertyName].hasOneOf) {
              <div
                class="one-of-checkbox"
                >
                <label
                  class="checkbox-label"
            [ngClass]="{
              'checkbox-disabled': propertiesInfo[propertyName].disabled
            }"
                  aria-hidden="true">
                  <input
                    type="checkbox"
                    [disabled]="propertiesInfo[propertyName].disabled"
                    [checked]="propertiesInfo[propertyName].useProp"
                    [(ngModel)]="propertiesInfo[propertyName].useProp"
                    [ngModelOptions]="{ standalone: true }"
                    [attr.name]="'Rset-' + propertyName"
                    class="primary-checkbox"
                    [attr.id]="'Rset-' + propertyName"
                    (change)="onCheckboxChange(propertyName, null, $event.target.checked)"
                    [attr.aria-label]="propertyTitle.join(' ')"
                    />
                    <span [attr.id]="'ztv-oneof-checkbox-' + propertyName" class="extra-border-enablefeat"></span>
                  </label>
                </div>
              }
              <div [attr.id]="'ztv-slider-title-' + propertyName" class="signifyBookmd disable-on-not-use">
                @for (title of propertyTitle; track title; let i = $index) {
                  <div class="nowrap" [attr.id]="'ztv-slider-title-line-' + propertyName + '-' + i">
                    {{ title }}
                  </div>
                }
              </div>
            </div>
            @if (quickConfigvalue) {
              <div class="col-2 disable-on-not-use">
                <div class="row">
                  <div class="col-2"></div>
                  <div class="col-2 minValMargin">
                    <span [attr.id]="'ztv-slider-min-std-' + propertyName" class="signifyBookmd minValue">
                      min {{ propertiesInfo[propertyName].sliderMin }}</span
                      >
                    </div>
                    <div class="col-3">
                      <span [attr.id]="'ztv-slider-max-std-' + propertyName" class="signifyBookmd maxValue">
                        max {{ propertiesInfo[propertyName].sliderMax }}</span
                        >
                      </div>
                    </div>
                  </div>
                }
                @if (!quickConfigvalue) {
                  <div class="minvalue col-1 disable-on-not-use">
                    <span [attr.id]="'ztv-slider-min-std-' + propertyName" class="signifyBookmd">{{
                      propertiesInfo[propertyName].sliderMin
                    }}</span>
                  </div>
                }
                @if (!quickConfigvalue) {
                  <div
                    [attr.id]="'ztv-slider-control-' + propertyName"
                    class="col-6 curvePadding sliderCss slider-container"
                    >
                    <ngx-slider
                      type="normalType"
                      class="slider-element"
                      [options]="propertiesInfo[propertyName].options"
                      [(value)]="propertiesInfo[propertyName]['value']"
                      (userChangeEnd)="onSliderValueChange($event.value, propertyName)"
                      ngDefaultControl
                      >
                    </ngx-slider>
                  </div>
                }
                @if (!quickConfigvalue) {
                  <div class="maxvalue col-1 disable-on-not-use">
                    <span [attr.id]="'ztv-slider-max-std-' + propertyName" class="signifyBookmd">{{
                      propertiesInfo[propertyName].sliderMax
                    }}</span>
                  </div>
                }
                <div class="slider-input-field row col-3 disable-on-not-use">
                  <div class="d-flex align-items-center">
                    <input
                      apInputError
                      [formControl]="ztvFormGroup.get(propertyName)"
                      appOnlynumber
                      [formControlName]="propertyName"
                      type="number"
                      [id]="propertyName"
            [ngClass]="{
              'quick-custom-inputbox textBoxUnit': quickConfigvalue,
              'custom-inputbox': !quickConfigvalue
            }"
                      class="form-control input-small textbox-standard"
                      />
                      <span [attr.id]="'ztv-slider-unit-' + propertyName" class="unit signifyBookmd ml-2">{{ unit }}</span>
                    </div>
                  </div>
                </div>
              </ng-template>
